import React from 'react'
import { useState } from 'react'
import Kotakmandate from './Kotakmandate'
import PaymentSystem from './PaymentSystem'
import UPI_Mandate from './UPI_Mandate'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import MandateOpt from './MandateOpt'
import Success from './Success'
import Login from './Login'
import OTP from './OTP'
import { useSelector } from 'react-redux'
import LoanInfo from './LoanInfo'
import Expiry from './Expiry'

function Step() {
  const { mandateData, language, otpTriggered, mandateID } = useSelector((state) => state.mandateInfo);
  const getPartner = useSelector((state) => state.mandateInfo.partner)
  const partner = getPartner ? getPartner : sessionStorage.getItem('partner');
  const { userLoggedIn } = useSelector((state) => state.mandateInfo);
  const [step, setStep] = useState(1)
  const mandateId = mandateID ? mandateID : sessionStorage.getItem("id")
  return (
    // <>
    //   {step === 2 && <Kotakmandate setStep={setStep}/>}
    //   {step === 1 && <PaymentSystem setStep={setStep} />}
    //   {step === 3 && <UPI_Mandate setStep={setStep}/>}
    // </>
    <BrowserRouter>
      <Routes>
        {/* {mandateData?.UMRNNumber && 
        <>
        <Route path="/success" element={<Success />} />
        <Route path="/*" element={<Success />} />
        </>
        } */}
        {(partner === 'chola-web' && !userLoggedIn) &&
          <>
            {!otpTriggered && 
            <>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Login />} />
            </>}
            {otpTriggered && 
            <>
            <Route path="/otp" element={<OTP />} />
            <Route path="/*" element={<OTP />} />
            </>}
          </>}
        {((partner === 'chola-web' && userLoggedIn) || mandateData?.Source_Sys !== 'chola-web' ) &&
          <>
            <Route path="/payment" element={<MandateOpt />} />
            {partner === 'chola-web' ? <Route path="/*" element={<LoanInfo />} /> :  <Route path="/*" element={<MandateOpt />} />    } 
            <Route path="/details" element={<LoanInfo />} />
            <Route path="/e-mandate" element={<Kotakmandate />} />
            <Route path="/upi-mandate" element={<UPI_Mandate />} />
            <Route path="/mandate-options" element={<PaymentSystem />} />
            {/* <Route path="/success" element={<Success />} /> */}
          </>} 
          {mandateData?.Status === 'Failure' && <Expiry/>}
      </Routes>
    </BrowserRouter>
  )
}

export default Step